import {Admin} from "../pages/Admin";
import {Soon} from "../pages/Soon";
import {Logout} from "../pages/admin/Logout";
import {News} from "../pages/admin/News";
import {Dashboard} from "../pages/admin/Dashboard";
import {AdminDashboard} from "../pages/admin/AdminDashboard";
import {List as NewsList} from "../pages/admin/news/List";
import {Edit as NewsEdit} from "../pages/admin/news/Edit";
import {Order as NewsOrder} from "../pages/admin/news/Order";
import {User} from "../pages/admin/User";
import {List as UserList} from "../pages/admin/user/List";
import {Edit as UserEdit} from "../pages/admin/user/Edit";
import {Album} from "../pages/admin/Album";
import {List as AlbumList} from "../pages/admin/album/List";
import {Edit as AlbumEdit} from "../pages/admin/album/Edit";
import {Partner} from "../pages/admin/Partner";
import {List as PartnerList} from "../pages/admin/partner/List";
import {Edit as PartnerEdit} from "../pages/admin/partner/Edit";
import {Document} from "../pages/admin/Document";
import {List as DocumentList} from "../pages/admin/document/List";
import {Edit as DocumentEdit} from "../pages/admin/document/Edit";
import {Order as DocumentOrder} from "../pages/admin/document/Order";
import {Office} from "../pages/admin/Office";
import {List as OfficeList} from "../pages/admin/office/office/List";
import {Add as OfficeAdd} from "../pages/admin/office/office/Add";
import {Show as OfficeShow} from "../pages/admin/office/office/Show";
import {Edit as OfficeEdit} from "../pages/admin/office/office/Edit";
import {List as MemberList} from "../pages/admin/office/member/List";
import {Edit as MemberEdit} from "../pages/admin/office/member/Edit";
import {Season} from "../pages/admin/Season";
import {List as SeasonList} from "../pages/admin/season/List";
import {Add as SeasonAdd} from "../pages/admin/season/Add";
import {Show as SeasonShow} from "../pages/admin/season/Show";
import {Edit as SeasonEdit} from "../pages/admin/season/Edit";
import {Race} from "../pages/admin/Race";
import {Add as RaceAdd} from "../pages/admin/race/Add";
import {Edit as RaceEdit} from "../pages/admin/race/Edit";
import {Participant as RaceParticipant} from "../pages/admin/race/Participant";
import {Participant} from "../pages/admin/Participant";
import {Add as ParticipantAdd} from "../pages/admin/participant/Add";
import {Edit as ParticipantEdit} from "../pages/admin/participant/Edit";
import {Equipment} from "../pages/admin/Equipment";
import {List as EquipmentList} from "../pages/admin/equipment/equipment/List";
import {Edit as EquipmentEdit} from "../pages/admin/equipment/equipment/Edit";
import {List as SizeList} from "../pages/admin/equipment/size/List";
import {Edit as SizeEdit} from "../pages/admin/equipment/size/Edit";
import {Order as SizeOrder} from "../pages/admin/equipment/size/Order";
import {List as CollectionList} from "../pages/admin/equipment/collection/List";
import {Edit as CollectionEdit} from "../pages/admin/equipment/collection/Edit";
import {Route} from "../pages/admin/Route";
import {List as RouteList} from "../pages/admin/route/route/List";
import {Edit as RouteEdit} from "../pages/admin/route/route/Edit";
import {List as CircuitList} from "../pages/admin/route/circuit/List";
import {Edit as CircuitEdit} from "../pages/admin/route/circuit/Edit";
import {List as StepList} from "../pages/admin/route/step/List";
import {List as BodyAreaList} from "../pages/admin/equipment/body-area/List";
import {Edit as BodyAreaEdit} from "../pages/admin/equipment/body-area/Edit";

const admin = {
  path: '/admin',
  element: <Admin/>,
  errorElement: <Admin/>,
  children: [
    {
      path: '',
      element: <Dashboard/>,
    },
    {
      path: 'logout',
      element: <Logout/>,
    },
    {
      path: 'profil',
      element: <AdminDashboard/>,
    },
    {
      path: 'user',
      element: <User/>,
      children: [
        {
          path: '',
          element: <UserList/>,
        },
        {
          path: 'add',
          element: <UserEdit/>,
        },
        {
          path: 'edit/:uuid',
          element: <UserEdit/>,
        },
      ]
    },
    {
      path: 'news',
      element: <News/>,
      children: [
        {
          path: '',
          element: <NewsList/>,
        },
        {
          path: 'add',
          element: <NewsEdit/>,
        },
        {
          path: 'edit/:uuid',
          element: <NewsEdit/>,
        },
        {
          path: 'order',
          element: <NewsOrder/>,
        },
      ]
    },
    {
      path: 'season',
      element: <Season/>,
      children: [
        {
          path: '',
          element: <SeasonList/>,
        },
        {
          path: 'add',
          element: <SeasonAdd/>,
        },
        {
          path: 'show/:uuid',
          element: <SeasonShow/>,
        },
        {
          path: 'edit/:uuid',
          element: <SeasonEdit/>,
        },
      ]
    },
    {
      path: 'office',
      element: <Office/>,
      children: [
        {
          path: 'office',
          element: <OfficeList/>,
        },
        {
          path: 'office/add',
          element: <OfficeAdd/>,
        },
        {
          path: 'office/show/:uuid',
          element: <OfficeShow/>,
        },
        {
          path: 'office/edit/:uuid',
          element: <OfficeEdit/>,
        },
        {
          path: 'member',
          element: <MemberList/>,
        },
        {
          path: 'member/add',
          element: <MemberEdit/>,
        },
        {
          path: 'member/edit/:uuid',
          element: <MemberEdit/>,
        },
      ]
    },
    {
      path: 'album',
      element: <Album/>,
      children: [
        {
          path: '',
          element: <AlbumList/>,
        },
        {
          path: 'add',
          element: <AlbumEdit/>,
        },
        {
          path: 'edit/:uuid',
          element: <AlbumEdit/>,
        },
      ],
    },
    {
      path: 'partner',
      element: <Partner/>,
      children: [
        {
          path: '',
          element: <PartnerList/>,
        },
        {
          path: 'add',
          element: <PartnerEdit/>,
        },
        {
          path: 'edit/:uuid',
          element: <PartnerEdit/>,
        },
      ],
    },
    {
      path: 'document',
      element: <Document/>,
      children: [
        {
          path: '',
          element: <DocumentList/>,
        },
        {
          path: 'add',
          element: <DocumentEdit/>,
        },
        {
          path: 'edit/:uuid',
          element: <DocumentEdit/>,
        },
        {
          path: 'order',
          element: <DocumentOrder/>,
        },
      ],
    },
    {
      path: 'race',
      element: <Race/>,
      children: [
        {
          path: 'add/:uuid?',
          element: <RaceAdd/>,
        },
        {
          path: 'edit/:uuid',
          element: <RaceEdit/>,
        },
        {
          path: 'participant/:uuid',
          element: <RaceParticipant/>,
        },
        {
          path: 'participant/:uuid',
          element: <RaceParticipant/>,
        },
      ]
    },
    {
      path: 'route',
      element: <Route/>,
      children: [
        {
          path: 'route',
          element: <RouteList/>,
        },
        {
          path: 'route/add',
          element: <RouteEdit/>,
        },
        {
          path: 'route/edit/:uuid',
          element: <RouteEdit/>,
        },
        {
          path: 'circuit/',
          element: <CircuitList/>,
        },
        {
          path: 'circuit/add',
          element: <CircuitEdit/>,
        },
        {
          path: 'circuit/edit/:uuid',
          element: <CircuitEdit/>,
        },
        {
          path: 'step',
          element: <StepList/>,
        },
      ]
    },
    {
      path: 'participant',
      element: <Participant/>,
      children: [
        {
          path: 'add/:uuid?',
          element: <ParticipantAdd/>,
        },
        {
          path: 'edit/:uuid',
          element: <ParticipantEdit/>,
        },
      ]
    },
    {
      path: 'equipment',
      element: <Equipment/>,
      children: [
        // Equipment
        {
          path: 'equipment',
          element: <EquipmentList/>,
        },
        {
          path: 'equipment/add',
          element: <EquipmentEdit/>,
        },
        {
          path: 'equipment/edit/:uuid',
          element: <EquipmentEdit/>,
        },
        // Size
        {
          path: 'size',
          element: <SizeList/>,
        },
        {
          path: 'size/order',
          element: <SizeOrder/>,
        },
        {
          path: 'size/add',
          element: <SizeEdit/>,
        },
        {
          path: 'size/edit/:uuid',
          element: <SizeEdit/>,
        },
        // Collection
        {
          path: 'collection',
          element: <CollectionList/>,
        },
        {
          path: 'collection/add',
          element: <CollectionEdit/>,
        },
        {
          path: 'collection/edit/:uuid',
          element: <CollectionEdit/>,
        },
        // Body Area
        {
          path: 'body-area',
          element: <BodyAreaList/>,
        },
        {
          path: 'body-area/add',
          element: <BodyAreaEdit/>,
        },
        {
          path: 'body-area/edit/:uuid',
          element: <BodyAreaEdit/>,
        },
      ],
    },
    {
      path: 'contact',
      element: <Soon/>,
    },
  ]
}

export default admin;